import { SavedSkeleton } from "@modules/slides-library/shared";
import { useGetArchivedFolders } from "../hooks";
import { RecursiveArchivedFolder } from "./recursive-archived-folder";

export const ArchivedFoldersTree = () => {
  const { tree, isLoading } = useGetArchivedFolders();

  if (isLoading) return <SavedSkeleton.Sidebar />;
  if (!tree.length) return null;

  return (
    <div className="tw-flex tw-flex-col tw-gap-0.5">
      {tree.map((folder) => (
        <RecursiveArchivedFolder key={folder._id} folder={folder} />
      ))}
    </div>
  );
};
